module.exports = __webpack_public_path__ + "img/default-logo.e9c516a5.png";